module.exports = __webpack_public_path__ + "static/media/share_person4.c244452b.png";